import { useEffect, useState } from "react";
import LogoIcon from "@/public/assets/app-images/blazeo_actual.png";

const useDesktopNotification = () => {
  const requestPermission = (data) => {
    if (Notification.permission === "default") {
      Notification.requestPermission().then((res) => {
        if (res == "granted" && data) {
          showNotification(data);
        }
      });
    }
  };

  const showNotification = async (data = {}) => {
    if (Notification.permission === "granted") {
      new Notification(data?.title, {
        body: data?.body,
        icon: LogoIcon,
      });
    } else if (Notification.permission === "default") {
      requestPermission(data);
    }
  };

  return {
    requestPermission,
    showNotification,
  };
};

export default useDesktopNotification;
